import { makeDesktopOrMobileComponent } from 'components/Media/makeDesktopOrMobile'
import type { GameInCategory } from 'containers/GamesBlock/types'

import { DesktopGamesGrid } from './Desktop/DesktopGamesGrid'
import { MobileGamesGrid } from './Mobile/MobileGamesGrid'

export interface Props {
  rows: number
  gameSlugs: GameInCategory[]
}

export const GamesGrid = makeDesktopOrMobileComponent(DesktopGamesGrid, MobileGamesGrid)
